export default "__VITE_PUBLIC_ASSET__becf004c__"